import i18next from "i18next";

export const getDefaultMessage = () => i18next.t("페이지를 표시할 수 없습니다. 잠시 후 다시 시도해주세요.");
